import script from "./UserDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./UserDialog.vue?vue&type=script&setup=true&lang=js"

import "./UserDialog.vue?vue&type=style&index=0&id=0b766b42&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b766b42"]])

export default __exports__